export enum SaleMediumTypeEnum{
    N_A = 0,
    EAT_IN,
    TAKEAWAY
}